<lib-form-field-container [kind]="FormContainerKind.Radio">
    <ng-content label select="[label]"></ng-content>
    <ng-content supportingText select="[supportingText]"></ng-content>
    <ng-container readOnly>
        <div #providedReadOnly class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">{{ formControl.value }}</div>
    </ng-container>

    <div class="sb-radio-card-group"
        role="radiogroup"
        [attr.aria-labelledby]="ariaLabel ? null : formFieldID + '-label'"
        [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
        [attr.aria-label]="ariaLabel || null"
        [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
        [attr.aria-required]="formControl.isRequired">
        <ng-content></ng-content>
    </div>
</lib-form-field-container>
